import { render, staticRenderFns } from "./candidate-filter-menu-item.vue?vue&type=template&id=a0ecc3d8&scoped=true&"
import script from "./candidate-filter-menu-item.vue?vue&type=script&lang=js&"
export * from "./candidate-filter-menu-item.vue?vue&type=script&lang=js&"
import style0 from "./candidate-filter-menu-item.vue?vue&type=style&index=0&id=a0ecc3d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0ecc3d8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VCheckbox,VIcon,VListItem,VListItemAction,VListItemContent,VListItemIcon,VListItemTitle,VProgressCircular,VSwitch})
